import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appFormatTime]',
})
export class FormatTimeDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const rawText = this.el.nativeElement.innerText?.trim();
    const formatted = this.formatToAMPM(rawText);
    this.el.nativeElement.innerText = formatted;
  }

  private formatToAMPM(time: string): string {
    if (!time || !time.includes(':')) return time;

    const [hour, minute] = time.split(':').map(Number);
    if (isNaN(hour) || isNaN(minute)) return time;

    const h = hour % 12 || 12;
    const ampm = hour >= 12 ? 'PM' : 'AM';

    return `${h.toString().padStart(2, '0')}:${minute
      .toString()
      .padStart(2, '0')} ${ampm}`;
  }
}
